import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  courseBanner: {
    backgroundColor: theme.palette.primary.light,
    borderRadius: 8,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
    textAlign: 'center',
  },
  courseTitle: {
    fontSize: 16,
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
  title: {
    fontSize: 28,
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    fontSize: 14,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(3),
  },
  field: {
    marginBottom: theme.spacing(2),
  },
  submitButton: {
    marginTop: theme.spacing(1),
    height: 48,
    fontWeight: 600,
    letterSpacing: 1,
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
    },
  },
}))

export default useStyles
